import { defineMessages } from "@formatjs/intl"
import type { VehicleTypeFilter } from "./VehicleTypeFilter"

export const vehicleTypeFilterMessages = defineMessages<VehicleTypeFilter>({
	CERTIFIED_USED_CAR: {
		defaultMessage: "Porsche Approved Pre-Owned",
		id: "vehicle.vehicleTypeFilter.certifiedUsedCar",
	},
	CLASSIC: {
		defaultMessage: "Classic",
		id: "vehicle.vehicleTypeFilter.classic",
	},
	COMMISSION_CAR: {
		defaultMessage: "Commission Car",
		id: "vehicle.vehicleTypeFilter.commissionCar",
	},
	COMPANY_CAR: {
		defaultMessage: "Company Car",
		id: "vehicle.vehicleTypeFilter.companyCar",
	},
	CUSTOMER_REPLACEMENT_CAR: {
		defaultMessage: "Customer Replacement Car",
		id: "vehicle.vehicleTypeFilter.customerReplacementCar",
	},
	DEMO_CAR: {
		defaultMessage: "Demo Car",
		id: "vehicle.vehicleTypeFilter.demoCar",
	},
	NEW_CAR: {
		defaultMessage: "New",
		id: "vehicle.vehicleTypeFilter.newCar",
	},
	USED_CAR: {
		defaultMessage: "Pre-Owned",
		id: "vehicle.vehicleTypeFilter.usedCar",
	},
})
